export default "__VITE_ASSET__C$KAm32w__"